module.exports = __webpack_public_path__ + "img/Matthias Tarasiewicz.4f740adc.jpg";